import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';

import CustomExpanderPanel from '@/features/administration/history/CustomExpanderPanel';

const OrderHistoryLoader = () => {
    const body = (
        <div className='display-flex justify-content-between'>
            <div className='display-flex'>
                <div className='display-flex flex-column gap-2'>
                    <ContentLoader height={20} width='50%' />
                    <ContentLoader height={14} width='35%' />
                </div>
            </div>
            <div className='display-flex'>
                <div className='display-flex flex-column gap-2'>
                    <ContentLoader height={20} width='50%' />
                    <ContentLoader height={14} width='35%' />
                </div>
            </div>
            <div className='display-flex'>
                <div className='display-flex flex-column gap-2'>
                    <ContentLoader height={20} width='50%' />
                    <ContentLoader height={14} width='35%' />
                </div>
            </div>
            <div className='display-flex'>
                <div className='display-flex flex-column gap-2'>
                    <ContentLoader height={20} width='50%' />
                    <ContentLoader height={14} width='35%' />
                </div>
            </div>
            <div className='display-flex'>
                <div className='display-flex flex-column gap-2'>
                    <ContentLoader height={20} width='50%' />
                    <ContentLoader height={14} width='35%' />
                </div>
            </div>
            <div className='flex-basis-5pct' />
        </div>
    );

    return (
        <div>
            <CustomExpanderPanel header={<ContentLoader height={20} width='100%' />} body={body} isDisabled />
            <CustomExpanderPanel header={<ContentLoader height={20} width='100%' />} body={body} isDisabled />
            <CustomExpanderPanel header={<ContentLoader height={20} width='100%' />} body={body} isDisabled />
        </div>
    );
};

export default OrderHistoryLoader;
